import React from 'react';
import { minutesToHuman, metersToHuman } from '../../../../../helpers/converters';

function Card(props) {
  const {
    id,
    slug,
    title,
    description,
    distanceMeters,
    tripTimeMinutes,
    startCoordinates,
    endCoordinates,
    active,
    city,
    difficultyLevel,

    company,
    place,
  } = props;

  return (
    <section className="row card card-body mb-3 shadow bg-light pricing-rates border-0 rounded" style={{ position: 'relative', zIndex: 9 }}>
      <div className="row">
        <div className="col-sm-8">
          <a href={`/firmy/${company.slug}`} className="h7 text-primary"  target='_blank'>
            <i className="uil uil-angle-right-b align-middle" style={{ position: 'relative', top: -1 }}></i> {company.title}
            {company.verified && (
              <i className="uil uil-check-circle" style={{ marginLeft: 5 }} title="Konto zweryfikowane"></i>
            )}
          </a>
          <h5 style={{ margin: 0 }}>{title}</h5>
          {tripTimeMinutes && (
            <p className="text-muted mb-0">
              <i className="uil uil-clock text-warning" style={{ marginRight: 5 }}></i>
              Czas spływu: <b>{minutesToHuman(tripTimeMinutes)}</b>
            </p>
          )}
          {distanceMeters && (
          <p className="text-muted mb-0">
              <i className="uil uil-crosshairs text-warning" style={{ marginRight: 5 }}></i>
              Długość: <b>{metersToHuman(distanceMeters)}</b>
            </p>
          )}
          <p className="text-muted mb-0">
            <i className="uil uil-location-pin-alt text-warning" style={{ marginRight: 5 }}></i>
            {/* {{-- <i className="uil uil-crosshairs text-warning"></i> --}} */}
            Rzeka: <b>{place.name || placeName}</b>
          </p>
          {city && (
            <p className="text-muted mb-0">
              <i className="uil uil-map-pin-alt text-warning" style={{ marginRight: 5 }}></i>
              Miejscowość: <b>{city}</b>
            </p>
          )}
          {/* {difficultyLevel && (
            <p className="text-muted">
              <i className="uil uil-map-pin-alt text-warning" style={{ marginRight: 5 }}></i>
              Trudno sc: <b>{city}</b>
            </p>
          )} */}

          {/* <p className="text-muted">{description}</p> */}
        </div>

        <div className="col-sm-4">
          {/* @if (is_array($route->tags) && count($route->tags))
            <p style="text-align: right">@foreach ($route->tags as $tag) <span className="badge bg-secondary">{{ $tag }}</span> @endforeach </p>
          @endif */}
          
          <div style={{ textAlign: 'right', marginTop: 30 }}>
            <a href={`/firmy/${company.slug}/trasy/${slug}`} target='_blank' className="btn btn-primary m-1">
              {active ? 'Rezerwuj' : 'Zobacz'}
              {/* <i className="uil uil-angle-right-b"></i> */}
            </a>
          </div>

          </div>
      </div>
    </section>
  )
}

export default Card;